// Values set in the Google Sheet script
enum ContentSubject {
  Art = 'art',
  ComputerScience = 'computerScience',
  English = 'english',
  Math = 'math',
  Science = 'science',
  SocialStudies = 'socialStudies',
}

type ContentSubjectMapping = { [index: string]: string };

export const ContentSubjectDescriptions: ContentSubjectMapping = {
  [ContentSubject.Art]: 'Art',
  [ContentSubject.ComputerScience]: 'Computer Science',
  [ContentSubject.English]: 'ELA',
  [ContentSubject.Math]: 'Math',
  [ContentSubject.Science]: 'Science',
  [ContentSubject.SocialStudies]: 'Social Studies',
};

export const MnStateStandardsKey: ContentSubjectMapping = {
  [ContentSubject.Art]: 'Arts',
  [ContentSubject.English]: 'ela',
  [ContentSubject.Math]: 'Math',
  [ContentSubject.Science]: 'sci',
  [ContentSubject.SocialStudies]: 'soc',
};

export default ContentSubject;
